import { IconsService } from '@/services/icon.service';
import { inject, provideEnvironmentInitializer } from '@angular/core';

export const provideIcons = () => {
  return [provideEnvironmentInitializer(() => inject(IconsService))];
};
